'use client';

import * as React from 'react';
import NextImage from 'next/image';
import { WidgetId } from '@/edge/constants';
import { Modal } from '@/shared/components/modal';
import { useEdgeConfigWidget } from '@/shared/modules/edge-config';
import { useProfileContext } from '../../hooks/use-profile-context';
import { useProfileDataQuery } from '../../hooks/use-profile-data-query';
import { ProfileEditForm } from './components/profile-edit-form';
import * as Styled from './profile-edit.styled';
interface ProfileEditProps {}
const DEFAULT_COVER_IMAGE = 'https://cdn-gpd.x-plarium.com/browser/content/portal/common/profile/games/pp-3.webp';
const DEFAULT_COVER_ALT = 'Cover image';
const DEFAULT_AVATAR_IMAGE = 'https://cdn-gpd.x-plarium.com/browser/content/portal/common/profile/games/pp-3.webp';
const DEFAULT_AVATAR_ALT = 'Avatar image';
export const ProfileEdit = React.memo(function ProfileEdit({}: ProfileEditProps) {
  const profileModel = useEdgeConfigWidget(WidgetId.Profile);
  const {
    isEditMode
  } = useProfileContext();
  const {
    data
  } = useProfileDataQuery();
  return <Modal isOpen={isEditMode} shouldCloseOnOverlayClick={false} onClose={() => null}>
      <Styled.Wrapper>
        <Styled.Title>{profileModel.strings.editProfile}</Styled.Title>

        <Styled.CoverAndAvatarHolder>
          <NextImage src={profileModel.images.coverBackgroundProfile ? profileModel.images.coverBackgroundProfile.src : DEFAULT_COVER_IMAGE} alt={profileModel.images.coverBackgroundProfile && profileModel.images.coverBackgroundProfile.alt || DEFAULT_COVER_ALT} width={630} height={210} />

          <Styled.AvatarImage src={data ? data.avatar : DEFAULT_AVATAR_IMAGE} alt={DEFAULT_AVATAR_ALT} width={100} height={100} />
        </Styled.CoverAndAvatarHolder>

        <ProfileEditForm />
      </Styled.Wrapper>
    </Modal>;
});